<div class="row">
    <div class="col-xs-5">{{teilnahmeStatusModel[statusBefore]}}</div>
    <div class="col-xs-2"><i class="fa fa-long-arrow-right"></i></div>
    <div class="col-xs-5">{{teilnahmeStatusModel[statusNow]}}</div>
</div>
